import { render, staticRenderFns } from "./EventResultEntry.vue?vue&type=template&id=ea195278&scoped=true"
import script from "./EventResultEntry.vue?vue&type=script&lang=js"
export * from "./EventResultEntry.vue?vue&type=script&lang=js"
import style0 from "./EventResultEntry.vue?vue&type=style&index=0&id=ea195278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea195278",
  null
  
)

export default component.exports